import { angular, app } from '../../app.module'
app
  // 一括タグ管理モーダル用のパネル
  .directive('batchTagPanel', ($window) => {
    return {
      restrict: 'E',
      template: require('./batch-tag-panel.pug')(),
      controller: function ($scope, $attrs) {
        $scope.tagType = $attrs.tagType
        $scope.snsType = $attrs.snsType
        let headerHeight: number

        // ヘッダ部分の高さを取得
        setTimeout(() => {
          headerHeight =
            angular.element('.main-nav').innerHeight() +
            angular.element('md-tabs-wrapper:first').innerHeight()
        }, 500)

        angular.element($window).bind('scroll', () => {
          // スクロール量を取得
          const scrollValue = angular.element($window).scrollTop()

          // スクロール位置に応じて位置を調整
          if (scrollValue > headerHeight) {
            angular
              .element('.batch-tag-panel')
              .css({ top: scrollValue - headerHeight, display: 'none' })
              .delay(300)
              .fadeIn('fast')
          } else {
            angular.element('.batch-tag-panel').css('top', 0)
          }
        })
      },
    }
  })
